export const MethodNotFound = -32601
